<template>
   <div class="row bgc-wrapper margin-top-42">
    <div class="col-lg-12 col-md-12 col-sm-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id="veh_laid_up"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#VehicleLaidup">
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Vehicle Laid Up</h3>
      </div>
    </div>
<div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="VehicleLaidup">
      <div class="risk row">
          <!--Laid up Applied* starts-->
          <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="row form-group">
              <float-label label="Laid up Applied*" :fixed="isFloat(vehicleLaidUpData.laidUpApplied.value)"> 
                <input
                  v-model="vehicleLaidUpData.laidUpApplied.value"
                  v-evolvews="vehicleLaidUpData.laidUpApplied"
                  type="text"
                  :class="{'bgc-error-field':vehicleLaidUpData.laidUpApplied.errorText !== '',}"
                  class="form-control"
                  placeholder="Laid up Applied*"
                />
              </float-label>
               <span class="error-text" v-if="vehicleLaidUpData.laidUpApplied.errorText !== ''">
                    {{vehicleLaidUpData.laidUpApplied.errorText}}</span>
            </div>
          </div>
          <!--Laid up Applied* ends-->
            <!--Post Laid up adjustment* starts-->
          <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="row form-group">
              <float-label label="Post Laid up adjustment*" :fixed="isFloat(vehicleLaidUpData.postLaidUpAdjustment.value)"> 
                <input
                  v-model="vehicleLaidUpData.postLaidUpAdjustment.value"
                  v-evolvews="vehicleLaidUpData.postLaidUpAdjustment"
                  type="text"
                  :class="{'bgc-error-field':vehicleLaidUpData.postLaidUpAdjustment.errorText !== '',}"
                  class="form-control"
                  placeholder="Post Laid up adjustment*"
                />
              </float-label>
               <span class="error-text" v-if="vehicleLaidUpData.postLaidUpAdjustment.errorText !== ''">
                    {{vehicleLaidUpData.postLaidUpAdjustment.errorText}}</span>
            </div>
          </div>
          <!--Post Laid up adjustment* ends-->
           <!--Laid up Period From starts-->
          <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="row form-group">
                    <float-label label="Laid up Period From*" :fixed="isFloat(vehicleLaidUpData.laidUpPeriodFrom.value)">
                        <datepicker
                        v-model="vehicleLaidUpData.laidUpPeriodFrom.value"
                        v-evolvews="vehicleLaidUpData.laidUpPeriodFrom"
                        :typeable="true"
                        format="dd/MM/yyyy"
                        placeholder="Laid up Period From*"
                        :input-class="isInputError(vehicleLaidUpData.laidUpPeriodFrom.errorText)"
                        @selected="checkError(vehicleLaidUpData.laidUpPeriodFrom,false)"
                        @input="checkError(vehicleLaidUpData.laidUpPeriodFrom,false)"
                        ></datepicker>
                    </float-label>
                    <span
                        class="error-text"
                        v-if="vehicleLaidUpData.laidUpPeriodFrom.errorText !== ''"
                    >{{vehicleLaidUpData.laidUpPeriodFrom.errorText}}</span>
                </div>
          </div>
          <!--Laid up Period From ends-->
           <!--Laid up Period To starts-->
          <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="row form-group">
                    <float-label label="Laid up Period To*" :fixed="isFloat(vehicleLaidUpData.laidUpPeriodTo.value)">
                        <datepicker
                        v-model="vehicleLaidUpData.laidUpPeriodTo.value"
                        v-evolvews="vehicleLaidUpData.laidUpPeriodTo"
                        :typeable="true"
                        format="dd/MM/yyyy"
                        placeholder="Laid up Period To*"
                        :input-class="isInputError(vehicleLaidUpData.laidUpPeriodTo.errorText)"
                        @selected="checkError(vehicleLaidUpData.laidUpPeriodTo,false)"
                        @input="checkError(vehicleLaidUpData.laidUpPeriodTo,false)"
                        ></datepicker>
                    </float-label>
                    <span
                        class="error-text"
                        v-if="vehicleLaidUpData.laidUpPeriodTo.errorText !== ''"
                    >{{vehicleLaidUpData.laidUpPeriodTo.errorText}}</span>
                </div>
          </div>
          <!--Laid up Period To ends-->
      </div>
    <div class="risk row">
           <!--Laid up start date starts-->
          <div class="col-lg-3 col-md-3 col-sm-6">
                <div class="row form-group">
                    <float-label label="Laid up start date*" :fixed="isFloat(vehicleLaidUpData.laidUpStartDate.value)">
                        <datepicker
                        v-model="vehicleLaidUpData.laidUpStartDate.value"
                        v-evolvews="vehicleLaidUpData.laidUpStartDate"
                        :typeable="true"
                        format="dd/MM/yyyy"
                        placeholder="Laid up start date*"
                        :input-class="isInputError(vehicleLaidUpData.laidUpStartDate.errorText)"
                        @selected="checkError(vehicleLaidUpData.laidUpStartDate,false)"
                        @input="checkError(vehicleLaidUpData.laidUpStartDate,false)"
                        ></datepicker>
                    </float-label>
                    <span
                        class="error-text"
                        v-if="vehicleLaidUpData.laidUpStartDate.errorText !== ''"
                    >{{vehicleLaidUpData.laidUpStartDate.errorText}}</span>
                </div>
            </div>
          
          <!--Laid up start date ends-->
           <!--Laid up End date date starts-->
          <div class="col-lg-3 col-md-3 col-sm-6">
                <div class="row form-group">
                    <float-label label="Laid up End date*" :fixed="isFloat(vehicleLaidUpData.laidUpEndDate.value)">
                        <datepicker
                        v-model="vehicleLaidUpData.laidUpEndDate.value"
                        v-evolvews="vehicleLaidUpData.laidUpEndDate"
                        :typeable="true"
                        format="dd/MM/yyyy"
                        placeholder="Laid up End date*"
                        :input-class="isInputError(vehicleLaidUpData.laidUpEndDate.errorText)"
                        @selected="checkError(vehicleLaidUpData.laidUpEndDate,false)"
                        @input="checkError(vehicleLaidUpData.laidUpEndDate,false)"
                        ></datepicker>
                    </float-label>
                    <span
                        class="error-text"
                        v-if="vehicleLaidUpData.laidUpEndDate.errorText !== ''"
                    >{{vehicleLaidUpData.laidUpEndDate.errorText}}</span>
                </div>
            </div>
          <!--Laid up End date ends-->
      </div>
    </div>
  </div>
</template>
<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import functions from "@/../../masters/functions.js";
import base from "@/../../masters/base.js";
import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
import vSelect from "vue-select";
import VueTimepicker from "vuejs-timepicker";
import { reactive, onUpdated } from "@vue/composition-api";
export default {
  name: "VehicleLaidUp",
  props: ["vehicleLaidUpData"],
  components: {
    FloatLabel,
    Datepicker,
    VueTimepicker
  },
  setup(props, context) {
    let state = reactive({});
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const onlyNumber = functions.onlyNumber;
    const isFloat =  functions.isFloat;
     onUpdated(()=>{
      let progressStep = 0;
      Object.values(props.vehicleLaidUpData).forEach(obj => {
        if(obj.stepsMandatory){
          if(obj.value && !obj.errorText){
            progressStep++;
          }
        }
      })
      context.parent.updateSteps(progressStep);
    })
    return {
      state,
      isFloat,
      checkError,
      isInputError,
      onlyNumber
    };
  },
  directives: {
    evolvews: functions.evolvews
  }
};
</script>


